<template>
  <div class="lcu-404-page">
    <div class="row row-center">
      <img class="lcu-404" src="./404.svg" alt="404 image" />
    </div>
    <div class="row row-center">
      <div class="row">
        <span class="lcu-404-text">404</span>
      </div>
      <div class="row">
        Oops, esta página no existe.
      </div>
    </div>
    <div class="row row-center lcu-back-row">
      <router-link
        class="lcu-auth-link"
        to="/">
        Regresar a Inicio
      </router-link>
    </div>
    <div class="row">
      <img class="lcu-404-logo" src="/assets/lcu-logo-gold-wide.svg" alt="lcu logo">
    </div>
  </div>
</template>

<script>
export default {
  name: 'not-found-page',
};
</script>

<style scoped lang="scss">
.lcu-404-page {
  background-color: $legacy-primary;
  color: $white;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.lcu-404 {
  width: 85%;

  @media screen and (min-width: $tablet-min) {
    width: 200px;
  }
}

.lcu-404-text {
  font-size: 72px;
}

.lcu-404-lost {
  font-size: 36px;
}

.lcu-auth-link {
  color: $legacy-secondary;
  text-decoration: none;
  transition-duration: .2s;

  &:before {
    content: '\e81f';
    display: inline-block;
    font-family: 'lcu';
    margin-right: 0;
  }

  &:hover {
    text-decoration: underline;
  }
}

.lcu-back-row {
  border-bottom: 1px solid rgba($white, .3);
  padding-bottom: 50px;
  width: 50%;
  margin: 0 auto;

  @media only screen and (max-width: $mobile-max) {
    width: 90%;
  }
}

.lcu-404-logo {
  width: 150px;
  margin: 15px auto;
}
</style>
